import {CustomFieldEntity, customFieldsStore} from "../data/CustomFieldsStore";
import {
	checkbox,
	Config,
	ContainerField,
	containerfield,
	datefield,
	DateTime,
	DisplayField,
	displayfield,
	Field,
	fieldset,
	Format,
	h4,
	numberfield,
	select,
	// t,
	textfield
} from "@intermesh/goui";
import {IfwInvalidator} from "../util/IfwInvalidator";
import {t} from "../util/Translate";

export function renderCustomDisplayField(f: CustomFieldEntity, p: any): DisplayField {
	let rendererFn = null, i = "star";
	switch (f.type) {
		case "date":
			rendererFn = (v: string): string => {
				if (v) {
					return (new DateTime(v)).format(Format.dateFormat);
				}
				return "";
			};
			break;
		case "checkbox":
			if (p) {
				i = "check_box";
			} else {
				i = "check_box_outline_blank";
			}
			rendererFn = (v: boolean, _fld: DisplayField): string => {
				return v ? t("Yes") : t("No");
			}
			break;
		default:
			break;
	}
	let parms = {
		icon: i,
		label: t(f.name),
		value: p,
	} as Config<DisplayField>;
	if (rendererFn) {
		Object.assign(parms, {renderer: rendererFn});
	}

	return displayfield(parms);
}

export async function renderCustomFieldForm(data: any, frontendMode: boolean = false, confirmMode = false): Promise<ContainerField> {

	const cntFld = containerfield(({name: "customFields"}))

	const res = await customFieldsStore.load(),
		fieldsets = frontendMode ? res.filter(r => r.displayFrontend): res;
	for (const cfs of fieldsets) {
		let fsTitle = cfs.name;
		if (frontendMode && cfs.readOnlyFrontend) {
			fsTitle += "&nbsp;<small>(" + t("Read-only") + ")</small>";
		}
		let ffs = fieldset({},
			h4({cls: "ifw-subtitle", html: fsTitle})
		);

		let items: Field[] = [];

		for (const cf of cfs.fields) {
			let fld;
			switch (cf.type) {
				case "text":
					fld = textfield({
						id: cf.databaseName + " " + cf.type,
						label: t(cf.name),
						name: cf.databaseName,
						icon: "star",
						cls: "with-icon",
						placeholder: cf.placeholder ? t(cf.placeholder) : " ",
						required: cf.required,
						readOnly: confirmMode || (frontendMode && cfs.readOnlyFrontend)
					})
					break;
				case "number":
					fld = numberfield({
						id: cf.databaseName + " " + cf.type,
						label: t(cf.name),
						name: cf.databaseName,
						cls: "with-icon",
						icon: "star",
						placeholder: cf.placeholder ? t(cf.placeholder) : " ",
						required: cf.required,
						readOnly: confirmMode || (frontendMode && cfs.readOnlyFrontend)
					})
					break;

				case "checkbox":
					fld = checkbox({
						id: cf.databaseName + " " + cf.type,
						label: t(cf.name),
						name: cf.databaseName,
						disabled: confirmMode || (frontendMode && cfs.readOnlyFrontend),
						required: cf.required
					});
					break;
				case "date":
					fld = datefield({
						id: cf.databaseName + " " + cf.type,
						label: t(cf.name),
						name: cf.databaseName,
						cls: "with-icon",
						icon: "event",
						required: cf.required,
						readOnly: confirmMode || (frontendMode && cfs.readOnlyFrontend),
						listeners: {
							invalid: IfwInvalidator.setTranslatedDateErrorMsg
						}
					});
					break;
				case "select":
					let fldOptions = [{value: "", name: ""}];
					for (const opt of cf.data.options) {
						fldOptions.push({value: opt, name: opt});
					}

					fld = select({
						id: cf.databaseName + " " + cf.type,
						label: t(cf.name),
						name: cf.databaseName,
						cls: "with-icon",
						icon: "star",
						required: cf.required,
						disabled: confirmMode || (frontendMode && cfs.readOnlyFrontend),
						options: fldOptions
					});

					break;
				default:
					console.warn("Unknown custom field type " + cf.type);
					continue;
			}
			if (cf.hintText) {
				fld!.hint = t(cf.hintText);
			}
			items.push(fld);
		}

		ffs.items.add(...items);

		cntFld.items.add(ffs);
	}

	cntFld.value = data.customFields ?? {};

	return cntFld;

}